import { render } from "./PurchasePage.vue?vue&type=template&id=68c3188e&scoped=true"
import script from "./PurchasePage.vue?vue&type=script&lang=js"
export * from "./PurchasePage.vue?vue&type=script&lang=js"

import "./PurchasePage.vue?vue&type=style&index=0&id=68c3188e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c3188e"]])

export default __exports__